import { SecondParty } from '@app/core/model/second-party.model'

export interface SecondPartyPagination {
  data: SecondPartyImport[]
  importedData?: SecondPartyImport[]
  empty?: boolean
  pageInfo: { pageNumber: number; pageSize: number; totalElements: number; totalPages: number }
}

export type SecondPartyImport = SecondParty & {
  selected?: boolean
  namingConflict?: boolean
  imported?: boolean
  newName?: string
}

export const DEFAULT_SECOND_PARTY_PAGINATION: SecondPartyPagination = {
  data: [],
  importedData: [],
  pageInfo: {
    pageNumber: 1,
    totalPages: 1,
    totalElements: 0,
    pageSize: 200,
  },
}
